module.exports = require('./lib/axios');


// WEBPACK FOOTER //
// ./src/frontend-lib/node_modules/axios/index.js